import { render, staticRenderFns } from "./ForgotPasswordForm.vue?vue&type=template&id=4f5983b6&scoped=true&"
import script from "./ForgotPasswordForm.vue?vue&type=script&lang=ts&"
export * from "./ForgotPasswordForm.vue?vue&type=script&lang=ts&"
import style0 from "./ForgotPasswordForm.vue?vue&type=style&index=0&id=4f5983b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5983b6",
  null
  
)

export default component.exports